export const getRouteReporting = (): { id: string; packageName: string; teamName: string } => ({
	id: 'issue-navigator',
	packageName: 'issueNavigator',
	teamName: 'empanada',
});
